const onClickOutside = (selector, func) => {
    document.body.addEventListener('mouseup', (e) => {
        if (!e.target.closest(selector)) func();
    });
};

const offClickOutside = (selector, func) => {
    document.body.removeEventListener('mouseup', (e) => {
        if (!e.target.closest(selector)) func();
    });
};

export {onClickOutside, offClickOutside};
